import React, { FC, useEffect } from 'react';
import clsx from 'clsx';
import styles from './TopMenuForSearch.module.scss';
import { ReactComponent as GoBackIcon } from 'images/new-icons/arrow-go-back.svg';
import { ReactComponent as ShareIconDark } from 'images/new-icons/share-filled-dark.svg';
import { useSpring } from '@react-spring/web';
import { useActions } from 'store/useActions';
import ShareDrawer from '../ShareDrawer';
import { useTypedSelector } from 'store/useTypedSelector';
import ArrowSvgLang from 'modules/app/components/UI/ArrowSvgLang';

type Props = {
  handleBack?: () => void;
  handleShare?: () => void;
};

const TopMenuForSearch: FC<Props> = ({ handleBack, handleShare }) => {

  return (
    <div className={clsx(styles.container)}>
      <ArrowSvgLang onClick={handleBack} />
      <ShareIconDark onClick={handleShare} />
    </div>
  );
};

export default TopMenuForSearch;
